export default __webpack_public_path__ + "static/media/radpad-mac.5c3b8472.png";